import React from 'react';
import s from './Customer.scss';
import get from 'lodash.get';
import isEqual from 'lodash.isequal';
import { Text, Layout, Cell, Box } from '@wix/design-system';
import { addressFormatter } from '@wix/crm-financial-formatters';
import { withTranslation } from '@wix/fe-essentials/i18n';
import { WithCustomerLoader } from '../../loaders/loaders-builder';
import { isMobileView } from '../../../core';
const Customer = withTranslation()(({ t, customer }) => {
    const email = get(customer, 'email.address');
    const companyName = get(customer, 'company.name');
    const name = get(customer, 'name');
    const phoneNumber = get(customer, 'phone.number');
    const vatId = get(customer, 'company.id');
    const billingAddress = get(customer, 'billingAddress', null);
    const shippingAddress = get(customer, 'shippingAddress', null);
    const addressLocalizedLocation = addressFormatter({
        t,
        // @ts-expect-error
        street: get(customer, 'address.street', null),
        // @ts-expect-error
        city: get(customer, 'address.city', null),
        // @ts-expect-error
        state: get(customer, 'address.state', null),
        // @ts-expect-error
        zip: get(customer, 'address.zip', null),
        // @ts-expect-error
        country: get(customer, 'address.country', null),
    });
    const billingAddressLocalizedLocation = addressFormatter({
        t,
        // @ts-expect-error
        street: get(customer, 'billingAddress.addressLine', null),
        // @ts-expect-error
        addressLine2: get(customer, 'billingAddress.addressLine2', null),
        // @ts-expect-error
        city: get(customer, 'billingAddress.city', null),
        // @ts-expect-error
        state: get(customer, 'billingAddress.subdivision', null),
        // @ts-expect-error
        zip: get(customer, 'billingAddress.postalCode', null),
        // @ts-expect-error
        country: get(customer, 'billingAddress.country', null),
    });
    const shippingLocalizedAddress = addressFormatter({
        t,
        // @ts-expect-error
        street: get(customer, 'shippingAddress.addressLine', null),
        // @ts-expect-error
        addressLine2: get(customer, 'shippingAddress.addressLine2', null),
        // @ts-expect-error
        city: get(customer, 'shippingAddress.city', null),
        // @ts-expect-error
        state: get(customer, 'shippingAddress.subdivision', null),
        // @ts-expect-error
        zip: get(customer, 'shippingAddress.postalCode', null),
        // @ts-expect-error
        country: get(customer, 'shippingAddress.country', null),
    });
    const shouldDisplayShippingAddress = !!(shippingAddress &&
        shippingLocalizedAddress &&
        !isEqual(shippingAddress, billingAddress) &&
        !isEqual(shippingLocalizedAddress, addressLocalizedLocation));
    const shouldDisplayCustomerAddress = (billingAddressLocalizedLocation || addressLocalizedLocation) !== '';
    const CustomerInfoTitle = ({ children, ...props }) => (React.createElement(Text, { size: "tiny", secondary: true, weight: "bold", light: true, ...props }, children));
    const hasAddress = !!(shouldDisplayCustomerAddress || shouldDisplayShippingAddress);
    const customerInfoTitleText = hasAddress
        ? t('invoice-view:price-quote.view.customer.additional-info-title')
        : t('invoice-view:price-quote.view.customer.customer-info-title');
    const recipient = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(Text, { size: "tiny", weight: "bold", secondary: true, dataHook: "customer-name" }, `${name}`),
            !!companyName && (React.createElement(Text, { size: "tiny", weight: "bold", secondary: true, dataHook: "company-name" }, companyName))));
    };
    const shippingAddressStyleMargin = () => {
        if (shouldDisplayCustomerAddress && !isMobileView()) {
            return '25px';
        }
        if (!shouldDisplayCustomerAddress) {
            return '0px';
        }
        if (shouldDisplayCustomerAddress && isMobileView()) {
            return '0px';
        }
    };
    const customerInfoMarginStyle = () => {
        if (isMobileView()) {
            return '0px';
        }
        if (shouldDisplayCustomerAddress && shouldDisplayShippingAddress) {
            return '48px';
        }
        if (hasAddress) {
            return '25px';
        }
        return '0px';
    };
    return (React.createElement("div", { className: s.customer, style: { paddingBottom: '35px' } },
        React.createElement(Layout, { alignItems: isMobileView() ? 'vertical' : 'horizontal' },
            shouldDisplayCustomerAddress && (React.createElement(Cell, { span: 4 },
                React.createElement(Box, { direction: "vertical", align: "left" },
                    React.createElement(CustomerInfoTitle, { dataHook: "billing-address-title" }, t('invoice-view:price-quote.view.customer.billing-address-title')),
                    recipient(),
                    React.createElement(Text, { size: "tiny", weight: "thin", secondary: true, dataHook: "customer-billing-address" }, billingAddressLocalizedLocation || addressLocalizedLocation)))),
            shouldDisplayShippingAddress && (React.createElement(Cell, { span: 4 },
                React.createElement(Box, { marginLeft: shippingAddressStyleMargin(), direction: "vertical", marginTop: isMobileView() ? '10px' : undefined },
                    React.createElement(CustomerInfoTitle, null, !shouldDisplayCustomerAddress
                        ? t('invoice-view:price-quote.view.customer.billing-address-title')
                        : t('invoice-view:price-quote.view.customer.shipping-address-title')),
                    !shouldDisplayCustomerAddress && recipient(),
                    React.createElement(Text, { size: "tiny", weight: "thin", secondary: true, dataHook: "customer-shipping-address" }, shippingLocalizedAddress)))),
            React.createElement(Cell, { span: 4 },
                React.createElement(Box, { direction: "vertical", marginLeft: customerInfoMarginStyle(), marginTop: isMobileView() ? '10px' : undefined },
                    React.createElement(CustomerInfoTitle, { dataHook: "customer-info-data-label" }, customerInfoTitleText),
                    !hasAddress && recipient(),
                    !!email && (React.createElement(Text, { size: "tiny", weight: "thin", secondary: true, dataHook: "customer-email" }, email)),
                    !!phoneNumber && (React.createElement(Text, { size: "tiny", weight: "thin", secondary: true, dataHook: "customer-phone-number" }, t('invoice-view:price-quote.view.customer.phone-title', {
                        phoneNumber,
                    }))),
                    !!vatId && (React.createElement(Text, { size: "tiny", weight: "thin", secondary: true, dataHook: "customer-vat-id" }, `${t('invoice-view:quote.form.vat_id')}: ${vatId}`)))))));
});
export default WithCustomerLoader(withTranslation(['invoice-view', 'locale-data'])(Customer));
//# sourceMappingURL=Customer.js.map